export const NAME_PRE_SALT_POLYGON_SUMMARY_ITEM = {
  label: 'Pre-salt Polygon',
  accessor: 'name',
};
